import React, { Component } from "react";
import ReactDOM from 'react-dom';
import DocumentFileItem from "./DocumentFileItem";
import axios from "axios"
import Pagination from "./Pagination";
import { LangContext } from "../LangContext.jsx";
class DocumentFilesPanel extends Component {
  static contextType = LangContext;

  constructor(props) {
    super(props);
    this.state = {
      filters: {},
      searchActive: false,
      pagination: { page: 1 },
      documents: { data: [] },
      files: { files: [], total: 0 },
    };
  }

  getDocuments = async () => {
    const request = await axios.get('/api/documents');
    this.setState({ documents: request.data });
  };

  getFiles = async () => {
    const request = await axios.get('/api/documents/files');
    this.setState({ files: request.data });
  };

  getFilteredFiles = async () => {
    const { filters, pagination } = this.state;
    const mixFilter = { ...filters };
    const query = new URLSearchParams();
    Object.keys(mixFilter).forEach((key) => {
      if (mixFilter[key] != "" && mixFilter[key] != 1) {
        query.append(key, mixFilter[key]);
      }
    });
    query.append('page', pagination.page);
    const qs = query.toString();
    if (qs !== "") {
      const request = await axios.get(`/api/documents/files?${qs}`);
      this.setState({ files: request.data, searchActive: true });
    } else {
      this.setState({ searchActive: false });
      this.getFiles();
    }
  };

  handleFiltering = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({ filters: { ...prev.filters, [name]: value } }));
  };

  updateCurrentPage = (tab, page) => {
    this.setState((prev) => ({ pagination: { ...prev.pagination, page } }));
  };

  componentDidMount() {
    this.getDocuments();
    this.getFiles();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filters !== this.state.filters || prevState.pagination.page !== this.state.pagination.page) {
      this.getFilteredFiles();
    }
  }

  render() {
    const { documents, files, pagination } = this.state;
    return (
    <>
      <div className="row">
        <div className="col-1 align-self-center ">
          <p className="font-weight-bold pt-2">Filtrar por</p>
        </div>

        <div className="col-3">
          <select
            onChange={this.handleFiltering}
            name="document_id"
            className="form-control form-control-solid bg-white">
            <option value="">Todos</option>
            {documents.data.map(doc => (
              <option value={doc.id} key={doc.id}>{doc.title}</option>
            ))}
          </select>
        </div>

        <div className="col-4">
        </div>

        <div className="col-4">
          <div className="input-icon">
            <input
              onChange={this.handleFiltering}
              name="search"
              type="text"
              className="form-control"
              placeholder="Buscar documentos" />
            <span>
              <i className="flaticon2-search-1 text-primary icon-md"></i>
            </span>
          </div>
        </div>
      </div>

      <h5 className="text-dark font-weight-bold my-5">
        <small className="text-muted font-weight-bold">Resultados de la búsqueda:</small>
        &nbsp; {files.total} &nbsp;
        <small className="text-muted font-weight-bold">documentos encontrados</small>
      </h5>

      <div className="card card-custom my-5">
        <div className="card-body">
          <table className="table table-borderless m-0 table-valign">
            <thead>
              <tr>
                <th colSpan="2">Nombre del archivo</th>
                <th>Invitado</th>
                <th>Estatus</th>
                <th>Fecha de Actualización</th>
              </tr>
            </thead>
            <tbody>
              {files.files.map((file, idx) => (
                <DocumentFileItem
                  key={idx}
                  file={file}
                />
              ))}
            </tbody>
          </table>

          {files.total > 10 &&
            <Pagination
              updateCurrentPage={this.updateCurrentPage}
              currentPage={pagination.page}
              totalFiles={files.total}
              split={10} />
          }
        </div>
      </div>
    </>
    )
  }
}

export default DocumentFilesPanel;

if (document.getElementById('DocumentFilesPanel')) {
    ReactDOM.render(<DocumentFilesPanel />, document.getElementById('DocumentFilesPanel'));
}
